// extracted by mini-css-extract-plugin
export default {"title":"styles_title__axOhl","containerOption":"styles_containerOption__d15YB"};